import React from 'react';
import {Box, Modal} from '@mui/material';
import './TermsOfUsePopUp.style.scss';
import TermsOfUseEn from "../../TermsOfUseView/TermsOfUseEn";
import TermsOfUseFr from "../../TermsOfUseView/TermsOfUseFr";
import TermsOfUseEs from "../../TermsOfUseView/TermsOfUseEs";
import {FormattedMessage, useIntl} from "react-intl";
import Button from "@mui/material/Button";

const TermsOfUsePopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const {locale} = useIntl();

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="termsOfUse-modal-title"
            aria-describedby="termsOfUse-modal-description"
            className={"TermsOfUsePopUp"}
        >
            <Box className="modal-box">
                <div className={"closeButton"} onClick={onClose}>X</div>
                {locale === "en" && <TermsOfUseEn/>}
                {locale === "fr" && <TermsOfUseFr/>}
                {locale === "es" && <TermsOfUseEs/>}
                <Button className={"iAgreeButton"}  onClick={onOk}>
                    <FormattedMessage id="popUp.termsOfUsePopUp.iAgree"/>
                </Button>
            </Box>

        </Modal>
    );
};

export default TermsOfUsePopUp;